import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import AccountReducers from './modules/account/reducers'
import AppReducer from './common/reducers'
import RegisterReducers from './modules/register/reducers'
import DashboardReducers from './modules/dashboard/reducers'
import ConfigReducers from './modules/config/reducers'
import TotemReducers from './modules/totem/reducers'
import CheckReducers from './modules/check/reducers'

let reducers = combineReducers({
    account: AccountReducers, 
    app: AppReducer,
    register: RegisterReducers,
    dashboard: DashboardReducers,
    config: ConfigReducers,
    totem: TotemReducers,
    check: CheckReducers
});
let store = createStore(reducers, applyMiddleware(thunk))
export default store